import React, { Component } from 'react';
import parse from 'html-react-parser';

class PageTakeoverPreview extends Component {
    render() {
        const htmlContent = (this.props.location && this.props.location.state && this.props.location.state.htmlContent) || '';

        return (
            <div class="sd_page_takeover">
                <div class="sd_page_takeover_inner" role="dialog" aria-modal="true" aria-label="Page announcement" tabindex="-1">
                    <button class="sd_page_takeover_close" aria-label="Close page takeover" onClick={() => this.props.history.goBack()}>
                        <span></span>
                        <span></span>
                    </button>
                    <div class="sd_page_takeover_content">
                        {parse(htmlContent)}
                    </div>
                </div>
            </div>
        );
    }
}

export default PageTakeoverPreview;
